import styled from 'styled-components';
import { customMedia } from 'styles/utils';

import { BaseEditField } from 'legacyComponents/styled/lib';
import { ButtonGroup } from 'legacyComponents/styles';

export const TableOfContentsStyled = styled.div`
  width: 17rem;
  height: 100%;
  padding: ${props => props.theme.spacing.default};
  padding-left: 0;
  position: sticky;
  top: 100px;

  ${customMedia.lessThan('large')`
    display: none;
  `}
`;

export const Wrapper = styled.ul`
  margin: 5px 0 10px 0;
  font-size: 0.9375em;
`;

export const SectionTitle = styled.div`
  padding: ${props => (props.active ? '0 0 20px 0' : '20px 0 0 0')};
`;

export const TitleWrapper = styled.div`
  padding: 30px 0 10px;
  display: flex;
  justify-content: space-between;
`;

export const SectionEditor = styled.div`
  background-color: ${props => props.theme.color.wfGrey100};
  border: ${props => (props.editable ? 1 : 0)}px solid
    ${props => props.theme.color.wfGrey200};
  box-shadow: none;
  margin-top: 20px;
  margin-bottom: 15px;
  min-height: 140px;
  font-size: 17px;
  line-height: 1.4;
  padding: 10px 2px;
  &:focus-within {
    border: 1px solid #457fca;
    box-shadow: inset 0 1px 2px rgba(27, 31, 35, 0.075),
      0 0 0 0.15em rgba(3, 102, 214, 0.3);
  }
`;

export const ReadmeSection = styled.div`
  position: relative;
  width: 100%;
  max-width: 58rem;
  padding: ${props => (props.last ? '0 3rem 1rem 3rem' : '0 3rem 0 3rem')};

  ${customMedia.lessThan('large')`
    width: 100%;
    margin-left: 0;
    padding: 0;
    padding-bottom: ${props => (props.last ? '1rem' : '0')};
  `}
`;

export const SectionTableTitle = styled.li`
  background-color: ${props => props.active && props.theme.color.wfGrey200};
  padding: ${props => props.theme.spacing.default}
    ${props => props.theme.spacing.small};
  padding-left: ${props => props.active && props.theme.spacing.medium};
  margin-bottom: ${props => props.theme.spacing.default};
  line-height: 1.25;
  min-height: 18px;
  transition: padding 250ms ease-in-out;
  color: ${props => props.theme.color.wfBlack};
  cursor: pointer;
  word-break: break-word;
  border-radius: ${props => props.theme.borderRadius.xlarge};
  &:hover {
    padding-left: ${props => props.theme.spacing.medium};
    background-color: ${props =>
      props.active ? props.theme.color.primary : props.theme.color.wfGrey200};
    color: ${props => props.active && props.theme.color.wfWhite};
  }
`;

export const MainWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 14rem;
  margin: 0 auto 1rem auto;
`;

export const MarkdownBodyWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto 1rem auto;
`;

export const EditorWrapper = styled.div`
  width: 100%;
  height: auto;
  background-color: ${props => props.theme.color.wfWhite};
  border: ${props => props.theme.color.wfWhite};
  padding: 10px 2px 30px;
  color: ${props => props.theme.color.wfGrey900};
  font-size: 17px;
  line-height: 1.4;
  margin-top: 20px;
  a {
    color: ${props => props.theme.color.primary};
    font-weight: 600;
  }

  ${customMedia.lessThan('small')`
    font-size: 15px;
    span {
      word-break: break-word;
    }
  `}
`;

export const ActiveEditorWrapper = styled(EditorWrapper)`
  background-color: ${props => props.theme.color.wfWhite};
  border: 1px solid
    ${props =>
      props.focussed ? props.theme.color.wfBlue : props.theme.color.wfGrey300};
  margin-top: 20px;
  margin-bottom: 15px;
  min-height: 140px;
`;

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 28px;
`;

export const Badge = styled.div`
  display: inline-block;
  margin: 12px 18px 0 0;
  transition: color 100ms ease-in-out;
  float: left;
  color: rgba(0, 0, 0, 0.6);
  background-color: #eeeeee;
  cursor: 'pointer';
`;

export const Name = styled.button`
  display: inline-block;
  border: none;
  background-color: none;
  font-size: 11px;
  color: inherit;
  background-color: inherit;
  border-radius: ${props => (props.rounded ? '3px' : '3px 0 0 3px')};
  padding: 5px 10px;
`;

export const Value = styled.div`
  display: inline-block;
  font-size: 11px;
  color: ${props => props.theme.color.wfWhite};
  background-color: ${props => props.setColor || 'rgba(0, 0, 0, 0.2)'};
  border-radius: 0 3px 3px 0;
  padding: 5px 10px;
  border-left: 1px solid ${props => props.theme.color.wfGrey200};
  cursor: pointer;
`;

export const Arrow = styled.div`
  display: inline-block;
  margin-left: 8px;
`;

export const Delete = styled.div`
  display: inline-block;
  margin-left: 10px;
  &:hover {
    transform: scale(1.3);
  }
`;

export const OptionsWrapper = styled.ul`
  display: block;
  position: relative;
  background-color: ${props => props.theme.color.wfWhite};
  padding: 1px 10px;
  box-shadow: rgba(0, 0, 0, 0.4) 0 0 1px;
  cursor: pointer;
`;

export const Option = styled.li`
  font-size: 15px;
  border-radius: 2px;
  margin: 10px 0;
  padding: 5px 20px 5px 10px;
  color: rgba(0, 0, 0, 0.65);
  transition: padding 250ms ease-in-out;
  cursor: pointer;
  &:hover {
    background-color: ${props => props.color || props.theme.color.primary};
    color: ${props => props.theme.color.wfWhite};
    padding: 5px 15px 5px 15px;
  }
`;

export const TitleInput = styled(BaseEditField)`
  padding: 5px 2px;
  margin: 15px 20px 15px 0;
  width: 400px;
  position: relative;
  > input {
    width: 390px;
    font-weight: 600;
    ::placeholder {
      font-weight: 600;
    }
  }
`;

export const SectionButtonGroup = styled(ButtonGroup)`
  justify-content: left;
`;
